import * as api from 'api/archive';

export const fetchArchiveQuestions = params => ({
  type: 'FETCH_ARCHIVE_QUESTIONS',
  payload: api.fetchArchiveQuestions(params),
});
